import { useQuery } from '@tanstack/react-query';
import type { AgentRetrySnooze } from '@erp/rpc';
import { orpc } from '@/api/rpc/client';

/**
 * The agent retry behind a task's active snooze, or null while loading, when
 * a person snoozed it, or when it is not snoozed. Only asks the server when
 * the snooze has no person behind it.
 *
 * `snoozedUntil` is part of the key: an agent that wakes and snoozes again
 * changes it, and that write never invalidates this browser's cache.
 */
export function useAgentRetrySnooze(
  taskId: string,
  snoozedUntil: Date | string | null | undefined,
  snoozedByAgent: boolean,
): AgentRetrySnooze {
  const input = { taskId };
  const query = useQuery(
    orpc.tasks.agentRetry.queryOptions({
      input,
      queryKey: [...orpc.tasks.agentRetry.queryKey({ input }), snoozedUntil],
      enabled: snoozedByAgent,
      retry: false,
    }),
  );
  return snoozedByAgent ? (query.data ?? null) : null;
}
